import { render, staticRenderFns } from "./chair_kunpeng.vue?vue&type=template&id=20dba772&scoped=true&"
import script from "./chair_kunpeng.vue?vue&type=script&lang=js&"
export * from "./chair_kunpeng.vue?vue&type=script&lang=js&"
import style0 from "./chair_kunpeng.vue?vue&type=style&index=0&id=20dba772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dba772",
  null
  
)

export default component.exports